module.exports = __webpack_public_path__ + "img/myclasses.a9b4b38b.jpg";